<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="chaptertitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Dedication</a></p>
<p class="toc sub"><a href="#/front02">Copyright</a></p>
<p class="toc"><a href="#/c01">Luneta</a></p>
<p class="toc"><a href="#/c02">The Storm Stone</a></p>
<p class="toc"><span href="#/c03" title="Link target outside of Sample">The Faery Ring</span></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">The Wooing of Lady Laudine</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">Laudine the Laughless</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">The Madness of Ywain</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">In the Other World</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">The Knight of the Lion</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">Questing</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">The Land of Diradvent</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">The Mightiest Battle Ever</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">The Lioness and Her Knight</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Author’s Note</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Sample Chapter from THE QUEST OF THE FAIR UNKNOWN</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">Buy the Book</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">Read More from the Squire’s Tales Series</span></p>
<p class="toc sub"><span href="#/back05" title="Link target outside of Sample">Middle Grade Mania!</span></p>
<p class="toc sub"><span href="#/back06" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/back07" title="Link target outside of Sample">Connect with HMH on Social Media</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6c9497f4